import { useEffect, useImperativeHandle, useState, type Ref } from 'react'
import { api } from '../../shared/api/http'

type Package = { revision: number; tier: number; billedTier: number; cycleEnd: string }
const labels = ['Sem IA — R$ 0/mês', 'Simples — R$ 19/mês', 'Avançado — R$ 20/mês']
export type CameraAiPackageHandle = { save: () => Promise<void> }
export function CameraAiPackageSelector({ companyId, clientId, cameraId, saveRef }: {
  companyId: string; clientId: string; cameraId: string; saveRef: Ref<CameraAiPackageHandle>
}) {
  const path = `/companies/${companyId}/clients/${clientId}/camera-provisioning/cameras/${cameraId}/ai-package`
  const [data, setData] = useState<Package | null>(null), [tier, setTier] = useState(0)
  const [busy, setBusy] = useState(false), [error, setError] = useState('')
  useEffect(() => {
    let active = true
    api<Package>(path).then(value => { if (active) { setData(value); setTier(value.tier) } })
      .catch(() => { if (active) setError('Não foi possível carregar o pacote de IA.') })
    return () => { active = false }
  }, [path])
  async function save() {
    if (!data || busy) throw new Error('Pacote indisponível')
    if (tier === data.tier) return
    setBusy(true); setError('')
    try {
      await api(path, { method: 'PUT', body: JSON.stringify({ revision: data.revision, tier }) })
      const value = await api<Package>(path); setData(value); setTier(value.tier)
    } catch { setError('Não foi possível salvar. O plano pode ter sido alterado; feche e abra a configuração para atualizar.'); throw new Error('Falha ao salvar pacote') }
    finally { setBusy(false) }
  }
  useImperativeHandle(saveRef, () => ({ save }))
  return <section aria-label="Pacote de IA da câmera" style={{ margin: '18px 0' }}>
    <h3>Pacote de IA</h3>
    {data && <><label>Valor por câmera<select value={tier} disabled={busy} onChange={event => setTier(Number(event.target.value))}>
      {labels.map((label, value) => <option key={value} value={value}>{label}</option>)}
    </select></label>
      <p>Avançado inclui Simples. A escolha também aparece em Plano. O pacote libera os analíticos para configurar abaixo.</p>
      {tier !== data.tier && <p>O acesso muda ao salvar. Neste ciclo permanece o maior pacote utilizado: R$ {[0, 25, 30][Math.max(data.billedTier, tier)]}. Reduções valem no próximo ciclo, em {data.cycleEnd.split('-').reverse().join('/')}.</p>}
    </>}
    {error && <p role="alert">{error}</p>}
  </section>
}
